import { ProfessionTypeMapping } from 'Components/apps/helsenett/HelsenettBusinessLogicData';

export function getAllOccupations(isHelsenettActive = false) {
    let helsenettProfessions = Object.keys(ProfessionTypeMapping);

    let sortedOccupations = Object.entries(this.trans('occupations')).sort(([keyA, valA], [keyB, valB]) => {
        return valA.localeCompare(valB);
    });

    return Object.keys(Object.fromEntries(sortedOccupations)).map((key) => {
        return {
            value: key.split('.').pop(),
            label: this.trans('occupations')[key]
        }
    }).filter((key) => {
        return isHelsenettActive
            ? helsenettProfessions.includes(key.value)
            : true;
    });
}
